import React from 'react';
import css from './ComingSoonSection.module.css';
import logoScanWow from './logo.png';

const ComingSoonSection = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.largeBoxWrapper}>
        {/* <img className={css.logoScanWow} src={logoScanWow} alt="Coming Soon" /> */}

        <p className={css.title}>Coming Soon!</p>
        <p className={css.body}>This page is currently being prepared.</p>
        <p className={css.smallPrint}>Details will be available shortly.</p>
      </div>

      <div className={css.divider}></div>
    </div>
  );
};

export default ComingSoonSection;
